import React from 'react';
import AtsTooltip from 'ats/components/ats-tooltip/AtsTooltip';

export default function CircularProgress({
	tooltip,
	tooltipPosition = 'top',
	size = 100,
	strokeWidth = 8,
	progress = 0,
	label = '',
	color = '#6172F3'
}) {
	const radius = (size - strokeWidth) / 2;
	const circumference = 2 * Math.PI * radius;
	const dashOffset = circumference - (progress / 100) * circumference;

	const progressElement = (
		<div
			className="circular-progress"
			style={{ width: size, height: size }}
			role="progressbar"
			aria-valuemin={0}
			aria-valuemax={100}
			aria-valuenow={progress}>
			<svg className="circular-progress__svg" width={size} height={size}>
				<circle
					className="circular-progress__bg"
					strokeWidth={strokeWidth}
					cx={size / 2}
					cy={size / 2}
					r={radius}
				/>
				<circle
					className="circular-progress__bar"
					strokeWidth={strokeWidth}
					cx={size / 2}
					cy={size / 2}
					r={radius}
					style={{
						strokeDasharray: circumference,
						strokeDashoffset: dashOffset,
						stroke: color
					}}
				/>
			</svg>

			{label && <div className="circular-progress__label">{label}</div>}
		</div>
	);

	if (tooltip) {
		return (
			<AtsTooltip text={tooltip} placement={tooltipPosition}>
				{progressElement}
			</AtsTooltip>
		);
	}

	return progressElement;
}
